import { createMerchantAuthenticationApi, type MerchantAuthenticationApi } from "./api.js";
import { dispatchMerchantTelemetry } from "../../shared/telemetry.js";
import type { BootstrapDependencies, MerchantBootstrapResponse } from "./models.js";
import { createBrowserTelemetrySink, type MerchantTelemetrySink } from "./telemetry.js";
import type { MerchantApiClient } from "../../types.js";

export interface MerchantBootstrapServiceOptions {
  api?: MerchantAuthenticationApi;
  apiClient?: MerchantApiClient;
  telemetry?: MerchantTelemetrySink;
}

export function createMerchantBootstrapService(
  options: MerchantBootstrapServiceOptions,
): BootstrapDependencies {
  const api = resolveAuthenticationApi(options);
  const telemetry = options.telemetry ?? createBrowserTelemetrySink();

  return {
    loadBootstrap() {
      return api.bootstrapSession();
    },
    track(eventName, payload) {
      telemetry.track(eventName, payload);
    },
  };
}

function resolveAuthenticationApi(
  options: MerchantBootstrapServiceOptions,
): MerchantAuthenticationApi {
  if (options.api !== undefined) return options.api;
  if (options.apiClient !== undefined) return createMerchantAuthenticationApi(options.apiClient);

  throw new Error("Merchant bootstrap service requires an authentication API or API client.");
}
